// extracted by mini-css-extract-plugin
export default {"wrapper":"GreyContainer_wrapper__0G45U","text":"GreyContainer_text__D4pAN"};